module.exports = __webpack_public_path__ + "static/media/bookCard.2670e975.svg";